import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { IoShareSocial } from "react-icons/io5";
import * as IconsSVG from "../../../../../../assets/iconsSVG";
import { RenderByCargo } from "../../../../../../utils/RenderByCargo";
import * as Styles from "../../styles";
import { Lead } from "../../../../../../interfaces";
import { isCorretor, isNonCorretor } from "../../constants";

interface Props {
  item: Lead;
  codigoCargo: string | null;
  usuarioGerenteOnline?: boolean;
}

const LeadLink: React.FC<{ nome: string; idLeadCorretor: string }> = ({
  nome,
  idLeadCorretor,
}) => (
  <Tooltip followCursor title={nome || "--"} placement="top-start" arrow>
    <Styles.LinkRef href={`/lead-detail/${idLeadCorretor}`}>
      {nome || "--"}
    </Styles.LinkRef>
  </Tooltip>
);

export const LeadCell: React.FC<Props> = ({
  item,
  codigoCargo,
  usuarioGerenteOnline,
}) => {
  const leadLink = (
    <LeadLink nome={item.nome} idLeadCorretor={item.idLeadCorretor} />
  );
  const leftPosition =
    isNonCorretor(codigoCargo) && !isCorretor(codigoCargo) ? 33 : 160;

  return (
    <Styles.ThirdFixedTd style={{ left: leftPosition }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: 8,
        }}
      >
        {usuarioGerenteOnline ? (
          leadLink
        ) : (
          <RenderByCargo
            cargo={codigoCargo}
            isCorretor={leadLink}
            isSuperintendente={leadLink}
            isGerenteVendas={leadLink}
          />
        )}
        {item.identificaCliente && (
          <Tooltip
            followCursor
            title="Já é cliente"
            placement="top-start"
            arrow
          >
            <span>
              <IconsSVG.SmallMedalIcon />
            </span>
          </Tooltip>
        )}
        {item?.possuiCompartilhamento && (
          <Tooltip
            followCursor
            title="Lead compartilhado"
            placement="top-start"
            arrow
          >
            <span>
              <IoShareSocial
                color="#2D5BFF"
                size={18}
                style={{ marginLeft: "4px" }}
              />
            </span>
          </Tooltip>
        )}
      </div>
    </Styles.ThirdFixedTd>
  );
};
